import flyoutMenu from '../../global/flyout-menu';

flyoutMenu(960, 'js_oraFlyoutButton', ['franchiseFlyoutOpen'], ['franchiseFlyoutInit']);
